import { useState, useEffect } from "react";
import axios from "axios";
import UserStatus from "../../components/UserStatus";
import "./styles/ReportPage.css";
import search from "/assets/icon/Search.svg";
import DownloadReportWindow from "../../components/DownloadReportWindow";

function ShowUserReport() {
  const [searchQuery, setSearchQuery] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showDownloadReport, setShowDownloadReport] = useState(false);

  const handleDownloadReportClick = () => {
    setShowDownloadReport(true);
  };

  const handleDownloadReportClose = () => {
    setShowDownloadReport(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSelection = () => {
    setSelectedBranch(null);
    setSearchQuery("");
    setUserData([]);
  };

  useEffect(() => {
    const fetchBranchData = async () => {
      if (searchQuery.trim() === "") {
        setBranchData([]); // Clear branch data if search query is empty
        return;
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/branchSearch?searchQuery=${searchQuery}`
        );
        console.log("Branch Data:", response.data); // Debug log
        setBranchData(response.data);
      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };

    fetchBranchData();
  }, [searchQuery]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!selectedBranch) {
        setUserData([]); // Clear user data if no branch is selected
        return;
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/usersByBranch?branchId=${selectedBranch.id}`
        );
        console.log("User Data:", response.data); // Debug log
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [selectedBranch]);

  const handleBranchClick = (branch) => {
    if (selectedBranch && selectedBranch.id === branch.id) {
      setSelectedBranch(null); // Deselect if clicking the same branch
      setSearchQuery(""); // Clear search query on deselect
    } else {
      setSelectedBranch(branch);
      setSearchQuery(branch.name); // Update search query with selected branch name
    }
  };

  const getPermissions = (user) => {
    const permissions = [];
    if (user.page_dashboard) permissions.push("Dashboard");
    if (user.page_alert) permissions.push("การแจ้งเตือน");
    if (user.page_weather) permissions.push("สภาพอากาศ");
    if (user.page_lighting) permissions.push("ควบคุมไฟ");
    if (user.page_gis) permissions.push("แผนที่");
    if (user.page_camera) permissions.push("กล้อง CCTV");
    if (user.page_display) permissions.push("จอ LED");
    return permissions.join(" / ");
  };

  return (
    <div className="showWeatherReport">
      <h1>รายงานผู้ใช้งานในระบบ SmartPole</h1>

      <h4 className="downloadReport" onClick={handleDownloadReportClick}>
        ดาวน์โหลดรายงาน
      </h4>

      <p>ค้นหาชื่อสาขา, รหัสสาขา</p>
      <div className="searchbarreport">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหาชื่อสาขา, รหัสสาขา"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {selectedBranch && (
            <button className="clear-button" onClick={handleClearSelection}>
              &times;
            </button>
          )}
        </div>
      </div>

      <div className="searchResults">
        {searchQuery && (
          <>
            {selectedBranch ? (
              <div
                className="resultItem"
                onClick={() => handleBranchClick(selectedBranch)}
                style={{ cursor: "pointer", border: "2px solid #2762F8" }}
              >
                <p>
                  <strong>ชื่อสาขา:</strong> {selectedBranch.name}
                </p>
                <p>
                  <strong>Location:</strong> {selectedBranch.location}
                </p>
                <p>
                  <strong>Latitude:</strong> {selectedBranch.lat},{" "}
                  {selectedBranch.lng}
                </p>
              </div>
            ) : (
              branchData.map((branch) => (
                <div
                  key={branch.id}
                  className="resultItem"
                  onClick={() => handleBranchClick(branch)}
                  style={{ cursor: "pointer" }}
                >
                  <p>
                    <strong>ชื่อสาขา:</strong> {branch.name}
                  </p>
                  <p>
                    <strong>Location:</strong> {branch.location}
                  </p>
                  <p>
                    {branch.lat},{branch.lng}
                  </p>
                </div>
              ))
            )}
          </>
        )}
      </div>
      <hr />

      {userData.length > 0 && (
        <>
          <h2>ผู้ใช้งานในสาขา {selectedBranch.name}</h2>
          <div className="showReportSection">
            <table className="sensorDataTable">
              <thead>
                <tr>
                  <th>ชื่อ</th>
                  <th>หมายเลขโทรศัพท์</th>
                  <th>อีเมล</th>
                  <th>สถานะ</th>
                  <th>สิทธิการเข้าถึงหน้าต่างๆ</th>
                </tr>
              </thead>
              <tbody>
                {userData.map((user) => (
                  <tr key={`${user.id}-${user.email}`}>
                    <td>{user.name}</td>
                    <td>{user.phone}</td>
                    <td>{user.email}</td>
                    <td className="w100">
                      <div className="w150">
                        <UserStatus isOnline={user.active} />
                      </div>
                    </td>
                    <td>{getPermissions(user)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {showDownloadReport && (
        <DownloadReportWindow
          onClose={handleDownloadReportClose}
          jsonData={{
            branchInfo: selectedBranch
              ? {
                  name: selectedBranch.name,
                  location: selectedBranch.location,
                  latitude: selectedBranch.lat,
                  longitude: selectedBranch.lng,
                  id: selectedBranch.id,
                }
              : null,
            userData: userData.map((user) => ({
              name: user.name,
              phone: user.phone,
              email: user.email,
              status: user.active ? "เปิดใช้งาน" : "ปิดใช้งาน",
              permissions: getPermissions(user),
            })),
          }}
          fileName={
            selectedBranch
              ? `${selectedBranch.name}_user_report`
              : "user_report"
          }
          routeName="showuserreport"
        />
      )}
    </div>
  );
}

export default ShowUserReport;
